import PropTypes from 'prop-types';
import ColorPicker from '@components/pickers/color-picker/color.picker.jsx';
import { formatColorName } from '@util/common.js';

export default function GroupedColorPicker({ bgColor, textColor, onChange }) {
  const donationAmountColors = [
    'light-aqua',
    'light-green',
    'dark-green',
    'light-yellow',
    'dark-yellow',
    'medium-grey',
  ];

  function filterColors(color) {
    return donationAmountColors.includes(color);
  }

  return (
    <>
      <span className="label-text mb-2">
        Progress bar: <b>{formatColorName(bgColor)}</b>
      </span>

      <ColorPicker
        currentColor={bgColor}
        fieldName="bgColor"
        onChange={onChange}
      />

      <span className="label-text mb-2">
        Donation amount: <b>{formatColorName(textColor)}</b>
      </span>

      <ColorPicker
        currentColor={textColor}
        fieldName="textColor"
        filterFunction={filterColors}
        onChange={onChange}
      />
    </>
  );
}

GroupedColorPicker.propTypes = {
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  onChange: PropTypes.func,
};
